module.exports = __webpack_public_path__ + "static/media/img9.38f492ed.jpg";